// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#Popup-module-actions {
  display: flex;
  gap: 5px;
  align-items: center;
}

#Popup-module-actions > button {
  padding: 0;
  height: 24px;
  width: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--text);
  background-color: transparent;
}

#Popup-module-popup {
  background-color: var(--background);
  overflow: hidden;
  transform: scale(0.8);
  height: 100%;
  width: 100%;
  transition: 0.15s;
  border-radius: 15px;
  max-height: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
}

#Popup-module-popup > section {
  background-color: inherit;
}

#Popup-module-popupContainer {
  left: 0;
  top: 0;
  position: fixed;
  z-index: 4;
  width: 100%;
  height: 100%;
  transition: 0.15s;
  opacity: 0;
  display: flex;
  pointer-events: none;
  justify-content: center;
  align-items: center;
}

#Popup-module-popupContainer.Popup-module-open {
  background-color: rgba(34, 34, 34, 0.752);
  backdrop-filter: blur(1px);
  opacity: 1;
  pointer-events: all;
}

#Popup-module-popupContainer.Popup-module-open #Popup-module-popup {
  transform: scale(1);
  border-radius: 0;
}

#Popup-module-popupContent {
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  overflow-y: auto;
}

#Popup-module-popupContent > form, #Popup-module-popupContent > form > section, #Popup-module-popupContent > section {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

#Popup-module-popupContent > h1 {
  font-size: 24px;
}

#Popup-module-popupHeader {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid var(--border);
  height: 40px;
  padding: 0 15px;
  flex-shrink: 0;
  align-items: center;
  font-weight: 300;
  color: var(--text);
}

@media screen and (min-width: 600px) {

  #Popup-module-popupContainer #Popup-module-popup {
    --popup-width-max: 1080px;
    border-radius: 5px;
    height: auto;
    box-shadow: var(--box-shadow-default);
    max-width: var(--popup-width-max);
    max-height: 720px;
  }

  #Popup-module-popupContainer.Popup-module-open #Popup-module-popup {
    border-radius: 5px;
  }

}`, "",{"version":3,"sources":["webpack://./src/components/Popup/Popup.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,MAAM;EACN,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,aAAa;EACb,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,0BAA0B;EAC1B,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sCAAsC;EACtC,YAAY;EACZ,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,qCAAqC;IACrC,iCAAiC;IACjC,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;AAEF","sourcesContent":["#actions {\n  display: flex;\n  gap: 5px;\n  align-items: center;\n}\n\n#actions > button {\n  padding: 0;\n  height: 24px;\n  width: 24px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: var(--text);\n  background-color: transparent;\n}\n\n#popup {\n  background-color: var(--background);\n  overflow: hidden;\n  transform: scale(0.8);\n  height: 100%;\n  width: 100%;\n  transition: 0.15s;\n  border-radius: 15px;\n  max-height: 100%;\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n#popup > section {\n  background-color: inherit;\n}\n\n#popupContainer {\n  left: 0;\n  top: 0;\n  position: fixed;\n  z-index: 4;\n  width: 100%;\n  height: 100%;\n  transition: 0.15s;\n  opacity: 0;\n  display: flex;\n  pointer-events: none;\n  justify-content: center;\n  align-items: center;\n}\n\n#popupContainer.open {\n  background-color: rgba(34, 34, 34, 0.752);\n  backdrop-filter: blur(1px);\n  opacity: 1;\n  pointer-events: all;\n}\n\n#popupContainer.open #popup {\n  transform: scale(1);\n  border-radius: 0;\n}\n\n#popupContent {\n  padding: 15px;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  overflow-y: auto;\n}\n\n#popupContent > form, #popupContent > form > section, #popupContent > section {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n#popupContent > h1 {\n  font-size: 24px;\n}\n\n#popupHeader {\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px solid var(--border);\n  height: 40px;\n  padding: 0 15px;\n  flex-shrink: 0;\n  align-items: center;\n  font-weight: 300;\n  color: var(--text);\n}\n\n@media screen and (min-width: 600px) {\n\n  #popupContainer #popup {\n    --popup-width-max: 1080px;\n    border-radius: 5px;\n    height: auto;\n    box-shadow: var(--box-shadow-default);\n    max-width: var(--popup-width-max);\n    max-height: 720px;\n  }\n\n  #popupContainer.open #popup {\n    border-radius: 5px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actions": `Popup-module-actions`,
	"popup": `Popup-module-popup`,
	"popupContainer": `Popup-module-popupContainer`,
	"open": `Popup-module-open`,
	"popupContent": `Popup-module-popupContent`,
	"popupHeader": `Popup-module-popupHeader`
};
export default ___CSS_LOADER_EXPORT___;
